(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wenzel-rip-n-ship"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__wzrRipNShip) return;
    window.__wzrRipNShip = true;

    function applyFilter(root, value) {
      var cards = root.querySelectorAll('.wzr-pcard');
      var featured = root.getAttribute('data-layout') === 'featured';
      var first = true;
      cards.forEach(function (card) {
        var show = value === 'all' || card.getAttribute('data-type') === value;
        card.hidden = !show;
        card.classList.remove('is-featured');
        if (show && first && featured) { card.classList.add('is-featured'); }
        if (show) { first = false; }
      });
      root.querySelectorAll('[data-wzr-filter]').forEach(function (tab) {
        var on = tab.getAttribute('data-wzr-filter') === value;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    document.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-wzr-filter]');
      if (tab) {
        var grid = tab.closest('[data-wzr-grid]');
        if (grid) { applyFilter(grid, tab.getAttribute('data-wzr-filter')); }
        return;
      }
      var arrow = event.target.closest('[data-wzr-scroll]');
      if (arrow) {
        var wrap = arrow.closest('[data-wzr-shorts]');
        var track = wrap && wrap.querySelector('[data-wzr-track]');
        if (track) {
          var dir = parseInt(arrow.getAttribute('data-wzr-scroll'), 10);
          track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.8, 240), behavior: reduceMotion ? 'auto' : 'smooth' });
        }
        return;
      }
      var sound = event.target.closest('[data-wzr-sound]');
      if (sound) { var sc = sound.closest('.wzr-short'); setSound(sc, sc.__wzrMuted !== false); return; }
      var toggle = event.target.closest('[data-wzr-toggle]');
      if (toggle) {
        var card = toggle.closest('.wzr-short');
        if (!card.__wzrFrame) { card.__wzrUserPaused = false; loadCard(card, true); setSound(card, true); }
        else if (card.__wzrPlaying) { card.__wzrUserPaused = true; pause(card); }
        else { card.__wzrUserPaused = false; play(card); }
      }
    });

    /* ---------- Shorts-style video carousel: muted autoplay while on screen, per-video sound toggle ---------- */
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var CARD_SEL = '.wzr-short[data-provider]:not([data-provider=""])';
    var allCards = function () { return document.querySelectorAll(CARD_SEL); };

    /* YouTube IFrame Player API: each card plays the channel's auto-updating playlist (or the manual links), and when a video
       ends it jumps to a random one that no other card is showing and that this card has not played recently. */
    var ytQueue = [], ytRequested = false, ytBad = {};
    function withYT(cb) {
      if (window.YT && window.YT.Player && window.YT.loaded) { cb(); return; }
      ytQueue.push(cb);
      if (ytRequested) return;
      ytRequested = true;
      var prevReady = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof prevReady === 'function') { try { prevReady(); } catch (e) {} }
        var q = ytQueue; ytQueue = [];
        q.forEach(function (f) { f(); });
      };
      if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        var s = document.createElement('script');
        s.src = 'https://www.youtube.com/iframe_api'; s.async = true;
        document.head.appendChild(s);
      }
    }
    var YT_ID = /(?:youtu\.be\/|\/shorts\/|\/embed\/|\/live\/|[?&]v=)([A-Za-z0-9_-]{11})/;
    function parseYT(line) {
      line = (line || '').trim();
      if (!line) return '';
      var m = line.match(YT_ID);
      if (m) return m[1];
      return /^[A-Za-z0-9_-]{11}$/.test(line) ? line : '';
    }
    function manualPool(wrap) {                // manual Video blocks + "More video links" (used when no channel ID is set)
      var ids = [];
      wrap.querySelectorAll('.wzr-short[data-provider="youtube"]').forEach(function (c) { var i = c.getAttribute('data-id'); if (i && ids.indexOf(i) < 0) ids.push(i); });
      (wrap.getAttribute('data-more') || '').split(/[\n\r,]+/).forEach(function (l) { var i = parseYT(l); if (i && ids.indexOf(i) < 0) ids.push(i); });
      return ids;
    }
    function takenIds(card) {                  // ids currently showing in the other cards of this carousel
      var t = {}, wrap = card.closest('[data-wzr-shorts]');
      if (!wrap) return t;
      wrap.querySelectorAll(CARD_SEL).forEach(function (c) {
        if (c === card) return;
        var id = c.__wzrExpect || c.__wzrCur || (!c.getAttribute('data-list') && c.getAttribute('data-id'));
        if (id) t[id] = true;
      });
      return t;
    }
    function pickNext(card, pool) {
      var taken = takenIds(card), hist = card.__wzrHist || [];
      var base = pool.filter(function (id) { return id && !taken[id] && !ytBad[id] && id !== card.__wzrCur && id !== card.__wzrExpect; });
      var fresh = base.filter(function (id) { return hist.indexOf(id) < 0; });
      var list = fresh.length ? fresh : base;
      return list.length ? list[Math.floor(Math.random() * list.length)] : null;
    }
    function ytPool(card) {
      var p = card.__wzrPlayer;
      if (card.getAttribute('data-list')) {
        var pl = null;
        if (!card.__wzrPl) { try { pl = p.getPlaylist(); } catch (e) {} if (pl && pl.length) card.__wzrPl = pl.slice(); }
        return card.__wzrPl || [];
      }
      return manualPool(card.closest('[data-wzr-shorts]') || document);
    }
    function ytNext(card) {                    // switch this card to a new random video (or replay if nothing else is free)
      var p = card.__wzrPlayer;
      if (!p) return;
      var id = pickNext(card, ytPool(card));
      if (!id) { try { p.seekTo(0, true); p.playVideo(); } catch (e) {} return; }
      card.__wzrExpect = id;
      try {
        p.loadVideoById(id);   // single-video mode (no playlist overlay / auto-advance); the channel playlist is only the pool
      } catch (e) {}
      card.__wzrNext = id;
    }
    function ytSetPoster(card, id) {
      if (!id) return;
      var poster = card.querySelector('.wzr-short__poster');
      if (poster) {
        poster.classList.remove('wzr-short__poster--skel');
        var img = poster.querySelector('img');
        if (!img) { img = document.createElement('img'); img.alt = ''; img.loading = 'eager'; poster.appendChild(img); }
        img.removeAttribute('srcset');
        img.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
      }
      var a = card.querySelector('.wzr-short__yt');
      if (a) a.href = 'https://www.youtube.com/shorts/' + id;
    }
    function ytSeedCarousel(wrap, pl, listId) {  // first paint = newest distinct Shorts from the channel playlist (no stale Video-block thumbs)
      if (!wrap || wrap.__wzrPlSeeded) return false;
      wrap.__wzrPlSeeded = true;
      wrap.__wzrPl = pl.slice(); for (var si = wrap.__wzrPl.length - 1; si > 0; si--) { var sj = Math.floor(Math.random() * (si + 1)), st = wrap.__wzrPl[si]; wrap.__wzrPl[si] = wrap.__wzrPl[sj]; wrap.__wzrPl[sj] = st; }  // shuffle: random set each load
      var cards = Array.prototype.slice.call(wrap.querySelectorAll('.wzr-short[data-list="' + listId + '"]'));
      var used = {};
      cards.forEach(function (c) {
        c.__wzrPl = wrap.__wzrPl.slice();
        var id = null;
        for (var j = 0; j < wrap.__wzrPl.length; j++) {
          var cand = wrap.__wzrPl[j];
          if (cand && !used[cand] && !ytBad[cand]) { id = cand; used[id] = true; break; }
        }
        if (!id) return;
        c.__wzrExpect = id;
        ytSetPoster(c, id);
        if (c.__wzrPlayer && c.__wzrReady) {
          try { c.__wzrPlayer.loadVideoById(id); } catch (e) {}
        }
      });
      return true;
    }
    function ytStartPlaylist(card, tries) {     // wait until playlist ids arrive; seed every card with distinct latest videos, then play
      var p = card.__wzrPlayer, pl = null;
      try { pl = p.getPlaylist(); } catch (e) {}
      if (pl && pl.length) {
        card.__wzrPl = pl.slice();
        var wrap = card.closest('[data-wzr-shorts]');
        var listId = card.getAttribute('data-list') || '';
        if (wrap && !wrap.__wzrPlSeeded) { ytSeedCarousel(wrap, pl, listId); return; }
        if (card.__wzrExpect) {
          ytSetPoster(card, card.__wzrExpect);
          try { p.loadVideoById(card.__wzrExpect); } catch (e) {}
          return;
        }
        ytNext(card);
        return;
      }
      if ((tries || 0) < 60) setTimeout(function () { ytStartPlaylist(card, (tries || 0) + 1); }, 250);
    }
    function ytApplySound(card) {
      var p = card.__wzrPlayer;
      try { if (card.__wzrMuted === false) { p.unMute(); p.setVolume(100); } else { p.mute(); } } catch (e) {}
    }
    function ytAcceptable(card, id) {
      var hist = card.__wzrHist || [];
      return !takenIds(card)[id] && !ytBad[id] && hist.indexOf(id) < 0;
    }
    function ytState(card, e) {
      var p = card.__wzrPlayer, S = window.YT.PlayerState;
      if (e.data === S.ENDED) {
        if (reduceMotion) {                      // reduced motion: stop at the end; the next tap plays a new random video
          card.__wzrPlaying = false; card.__wzrNeedNext = true; card.classList.add('is-paused');
          return;
        }
        ytNext(card);
        return;
      }
      if (e.data === S.PLAYING) {
        var id = '';
        try { id = (p.getVideoData() || {}).video_id || ''; } catch (err) {}
        if (id && id !== card.__wzrCur) {
          if (card.__wzrExpect && id !== card.__wzrExpect && card.getAttribute('data-list')) { try { p.loadVideoById(card.__wzrExpect); } catch (err) {} return; }   // channel feed: never reveal a stray playlist video (e.g. index 0 after refresh); load the shuffled pick
          if (card.__wzrExpect && id !== card.__wzrExpect && !ytAcceptable(card, id)) { ytNext(card); return; }   // something else started (e.g. playlist index 0) and it's a duplicate
          card.__wzrExpect = null;
          card.__wzrCur = id;
          card.setAttribute('data-current', id);
          var hist = card.__wzrHist = card.__wzrHist || [];
          hist.push(id); if (hist.length > 8) hist.shift();
          ytSetPoster(card, id);   // keep the poster in sync with the current video
        }
        card.classList.add('is-loaded');
        try { p.unloadModule('captions'); } catch (err) {}
        ytApplySound(card);
        if (!card.__wzrPlaying) { try { p.pauseVideo(); } catch (err) {} }
      }
    }
    function loadYT(card) {
      var media = card.querySelector('[data-wzr-media]');
      if (!media) return;
      var host = document.createElement('div');
      media.appendChild(host);
      card.__wzrFrame = host;
      card.__wzrPlaying = true;
      if (card.__wzrMuted === undefined) card.__wzrMuted = true;
      var list = card.getAttribute('data-list');
      var vars = { autoplay: list ? 0 : 1, mute: 1, controls: 0, playsinline: 1, modestbranding: 1, rel: 0, iv_load_policy: 3, cc_load_policy: 0, disablekb: 1, fs: 0, enablejsapi: 1 };
      if (location.origin && location.origin !== 'null') vars.origin = location.origin;
      var opts = { host: 'https://www.youtube-nocookie.com', width: '100%', height: '100%', playerVars: vars, events: {
        onReady: function () {
          card.__wzrReady = true;
          var p = card.__wzrPlayer, f = p.getIframe && p.getIframe();
          if (f) { f.setAttribute('tabindex', '-1'); var cap = card.querySelector('.wzr-short__cap'); f.title = cap ? cap.textContent : 'Video'; }
          ytApplySound(card);
          if (list) { try { p.setShuffle(true); } catch (e) {} ytStartPlaylist(card, 0); }
          else { card.__wzrExpect = card.getAttribute('data-id'); if (card.__wzrPlaying) p.playVideo(); }
        },
        onStateChange: function (e) { ytState(card, e); },
        onError: function () {                   // removed / not embeddable: skip it
          var id = card.__wzrExpect || card.__wzrCur;
          if (id) ytBad[id] = true;
          card.__wzrExpect = null;
          ytNext(card);
        }
      } };
      if (list) { vars.listType = 'playlist'; vars.list = list; } else { opts.videoId = card.getAttribute('data-id'); }
      withYT(function () { card.__wzrPlayer = new window.YT.Player(host, opts); });
      setTimeout(function () { if (!list || card.__wzrCur) card.classList.add('is-loaded'); }, 4000);   // fallback (channel feed: only once the shuffled pick really plays — keep poster/skeleton otherwise): reveal the player even if it never reports PLAYING
    }
    window.__wzrShorts = { next: ytNext, pick: pickNext, parse: parseYT, pool: manualPool };

    function post(card, func, args) {
      if (card.__wzrPlayer || card.getAttribute('data-provider') === 'youtube') {
        var yp = card.__wzrPlayer;
        if (!yp || !card.__wzrReady || typeof yp[func] !== 'function') return;
        try { yp[func].apply(yp, args || []); } catch (e) {}
        return;
      }
      var f = card.__wzrFrame;
      if (!f || !f.contentWindow || !card.__wzrReady) return;
      var msg;
      if (card.getAttribute('data-provider') === 'vimeo') {
        var map = { playVideo: ['play'], pauseVideo: ['pause'], mute: ['setVolume', 0], unMute: ['setVolume', 1] };
        if (!map[func]) return;
        msg = { method: map[func][0] };
        if (map[func].length > 1) msg.value = map[func][1];
      } else {
        msg = { event: 'command', func: func, args: args || [] };
      }
      f.contentWindow.postMessage(JSON.stringify(msg), '*');
    }
    function buildSrc(card) {
      var id = card.getAttribute('data-id');
      if (card.getAttribute('data-provider') === 'vimeo') {
        return 'https://player.vimeo.com/video/' + id + '?autoplay=1&muted=1&loop=1&controls=0&title=0&byline=0&portrait=0&playsinline=1&dnt=1';
      }
      var q = 'autoplay=1&mute=1&loop=1&playlist=' + id + '&controls=0&playsinline=1&modestbranding=1&rel=0&iv_load_policy=3&disablekb=1&fs=0&enablejsapi=1';
      if (location.origin && location.origin !== 'null') q += '&origin=' + encodeURIComponent(location.origin);
      return 'https://www.youtube-nocookie.com/embed/' + id + '?' + q;
    }
    function applyState(card) {            // push our wanted state (playing / muted) into the player once it is ready
      post(card, card.__wzrPlaying ? 'playVideo' : 'pauseVideo');
      if (card.__wzrMuted === false) { post(card, 'unMute'); post(card, 'setVolume', [100]); } else { post(card, 'mute'); }
    }
    function markReady(card) {
      if (card.__wzrReady) return;
      card.__wzrReady = true;
      clearInterval(card.__wzrPing);
      card.classList.add('is-loaded');
      applyState(card);
    }
    function loadCard(card) {
      if (card.__wzrFrame) return;
      if (card.getAttribute('data-provider') === 'youtube') { loadYT(card); return; }
      var media = card.querySelector('[data-wzr-media]');
      if (!media) return;
      var f = document.createElement('iframe');
      var cap = card.querySelector('.wzr-short__cap');
      f.title = cap ? cap.textContent : 'Video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture';
      f.setAttribute('tabindex', '-1');
      f.src = buildSrc(card);
      card.__wzrFrame = f;
      card.__wzrPlaying = true;
      if (card.__wzrMuted === undefined) card.__wzrMuted = true;
      f.addEventListener('load', function () {
        var n = 0;   // say "listening" until the player answers (same handshake the official IFrame API uses)
        card.__wzrPing = setInterval(function () {
          if (card.__wzrReady || ++n > 30) { clearInterval(card.__wzrPing); return; }
          try { f.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: card.getAttribute('data-id'), channel: 'widget' }), '*'); } catch (e) {}
        }, 250);
        setTimeout(function () { card.classList.add('is-loaded'); }, 2500);   // fallback: reveal the video even if no API reply
      });
      media.appendChild(f);
    }
    function play(card) {
      if (!card.__wzrFrame) { loadCard(card); return; }
      card.__wzrPlaying = true; card.classList.remove('is-paused'); card.classList.remove('is-idle');
      if (card.__wzrNeedNext && card.__wzrPlayer) { card.__wzrNeedNext = false; ytNext(card); return; }
      post(card, 'playVideo');
    }
    function pause(card, auto) {
      if (!card.__wzrFrame) return;
      card.__wzrPlaying = false; card.classList.add(auto ? 'is-idle' : 'is-paused'); post(card, 'pauseVideo');
    }
    function setSound(card, on) {
      var btn = card.querySelector('[data-wzr-sound]');
      if (on) {
        allCards().forEach(function (c) { if (c !== card && c.__wzrMuted === false) setSound(c, false); });   // only one video speaks at a time
        card.__wzrMuted = false; card.__wzrUserPaused = false;
        if (!card.__wzrFrame) loadCard(card); else { play(card); post(card, 'unMute'); post(card, 'setVolume', [100]); }
      } else {
        card.__wzrMuted = true; post(card, 'mute');
      }
      if (btn) { btn.setAttribute('aria-pressed', on ? 'true' : 'false'); btn.setAttribute('aria-label', on ? 'Mute' : 'Turn sound on'); }
    }
    window.addEventListener('message', function (e) {
      if (!/(^|\.)(youtube-nocookie\.com|youtube\.com|vimeo\.com)$/.test((e.origin || '').replace(/^https?:\/\//, ''))) return;
      var card = null;
      allCards().forEach(function (c) { if (c.__wzrFrame && c.__wzrFrame.contentWindow === e.source) card = c; });
      if (!card) return;
      var d = e.data;
      if (typeof d === 'string') { try { d = JSON.parse(d); } catch (err) { return; } }
      if (d && (d.event === 'onReady' || d.event === 'initialDelivery' || d.event === 'infoDelivery' || d.event === 'ready')) markReady(card);
    });

    function updateArrows(wrap) {
      var track = wrap.querySelector('[data-wzr-track]');
      var prev = wrap.querySelector('[data-wzr-scroll="-1"]');
      var next = wrap.querySelector('[data-wzr-scroll="1"]');
      if (!track || !prev || !next) return;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    function initShorts(wrap) {
      if (wrap.__wzrInit) return;
      wrap.__wzrInit = true;
      var track = wrap.querySelector('[data-wzr-track]');
      var auto = wrap.getAttribute('data-autoplay') === 'true' && !reduceMotion;
      if (track) {
        track.addEventListener('scroll', function () { updateArrows(wrap); }, { passive: true });
        window.addEventListener('resize', function () { updateArrows(wrap); });
        updateArrows(wrap);
      }
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var card = en.target;
          card.__wzrVisible = en.isIntersecting && en.intersectionRatio >= 0.6;
          if (card.__wzrVisible) {
            if (auto && !card.__wzrUserPaused && !document.hidden) play(card);   // lazy: the iframe is created here, on first view
          } else if (card.__wzrPlaying) {
            pause(card, true);                                                   // off screen (scrolled away or carousel moved)
          }
        });
      }, { threshold: [0, 0.6] });
      wrap.querySelectorAll(CARD_SEL).forEach(function (c) { io.observe(c); });
      wrap.__wzrIO = io;
    }
    /* ---------- Featured product wheel: 3D coverflow ring that spins slowly and endlessly; drag / swipe / scroll / arrows to spin it by hand ---------- */
    function hydrateSlide(slide) {
      if (!slide) return;
      slide.querySelectorAll('img[data-wzr-src]').forEach(function (img) {
        var ss = img.getAttribute('data-wzr-srcset');
        if (ss) img.setAttribute('srcset', ss);
        img.setAttribute('src', img.getAttribute('data-wzr-src'));
        img.removeAttribute('data-wzr-src');
        img.removeAttribute('data-wzr-srcset');
      });
    }
    function initRotator(root) {
      if (root.__wzrInit) return;
      root.__wzrInit = true;
      var box = root.querySelector('.wzr-rot');
      var ring = root.querySelector('[data-wzr-ring]');
      var infoWrap = root.querySelector('.wzr-rot__info');
      var emptyEl = root.querySelector('[data-wzr-rot-empty]');
      var viewAll = root.querySelector('[data-wzr-view-all]');
      var catBar = root.querySelector('.wzr-rot-cats');
      var slides = [];
      var infos = [];
      var n = 0;
      var spp = parseFloat(root.getAttribute('data-speed')) || 0;
      var hideSold = root.getAttribute('data-hide-sold') === 'true';
      var maxProducts = parseInt(root.getAttribute('data-max'), 10) || 250;
      var btnLabel = root.getAttribute('data-btn-label') || 'SHOP IT';
      var addLabel = root.getAttribute('data-add-label') || '';
      var cartUrl = root.getAttribute('data-cart-url') || '/cart/add';
      var moneyFormat = root.getAttribute('data-money-format') || '';
      var POS = [0, .5, .8, .99, 1.15], SCALE = [1, .74, .58, .47, .4], ROT = [0, 34, 44, 50, 54], FADE = [1, .72, .45, .22, 0];
      var BASE = 0, pos = 0, vel = 0, active = 0, side = 3, half = 0;
      var hover = false, focused = false, visible = !('IntersectionObserver' in window);
      var drag = null, tween = null, wheelUntil = 0, raf = 0, last = 0, shown = [];
      var moved = false;
      var catCache = {};
      var catLoading = false;
      var spinHintHtml = '';
      function isMobile() { return window.innerWidth < 750; }

      function refreshRefs() {
        slides = Array.prototype.slice.call(root.querySelectorAll('[data-wzr-slide]'));
        infos = Array.prototype.slice.call(root.querySelectorAll('[data-wzr-info]'));
        n = slides.length;
        BASE = (!reduceMotion && n > 1 && spp > 0) ? 1 / spp : 0;
        /* Mobile: slower auto-spin so packs are readable (was 2.4x faster — too quick) */
        if (BASE > 0 && isMobile()) BASE *= 0.55;
      }
      function wrap(v) { return n ? (((v % n) + n) % n) : 0; }
      function lerpArr(arr, a) { var j = Math.floor(a), f = a - j; return arr[j] + (arr[Math.min(j + 1, arr.length - 1)] - arr[j]) * f; }
      function measure() {
        if (!box || !ring) return;
        var v = parseInt(getComputedStyle(box).getPropertyValue('--wzr-side'), 10) || 3;
        side = n ? Math.max(0, Math.min(v, Math.floor((n - 1) / 2), 3)) : 0;
        half = ring.clientWidth / 2;
        if (isMobile()) half *= 1.02;
      }
      function stepPx() {
        var base = Math.max(48, half * POS[1]);
        /* Mobile: shorter drag distance per product = snappier swipe */
        return isMobile() ? Math.max(28, base * 0.42) : base;
      }
      function setActive(k) {
        if (!n || k === active) return;
        if (infos[active]) { infos[active].classList.remove('is-active'); infos[active].setAttribute('aria-hidden', 'true'); infos[active].setAttribute('inert', ''); }
        if (infos[k]) { infos[k].classList.add('is-active'); infos[k].removeAttribute('aria-hidden'); infos[k].removeAttribute('inert'); }
        if (slides[active]) slides[active].classList.remove('is-active');
        if (slides[k]) slides[k].classList.add('is-active');
        active = k;
      }
      function layout() {
        if (!n) return;
        var p = wrap(pos), lim = side + 1, now = [];
        for (var k = 0; k < n; k++) {
          var d = k - p;
          if (d > n / 2) d -= n; else if (d < -n / 2) d += n;
          var a = Math.abs(d);
          if (a >= lim) continue;
          var sl = slides[k], sg = d < 0 ? -1 : 1;
          var fade = a <= side ? lerpArr(FADE, a) : FADE[side] * (lim - a);
          sl.style.transform = 'translateX(' + (sg * half * lerpArr(POS, a)).toFixed(1) + 'px) translateZ(' + (-a * 60).toFixed(1) + 'px) rotateY(' + (-sg * lerpArr(ROT, a)).toFixed(2) + 'deg) scale(' + lerpArr(SCALE, a).toFixed(4) + ')';
          sl.style.opacity = fade.toFixed(3);
          sl.style.zIndex = String(100 - Math.round(a * 10));
          if (!sl.__wzrNear) { sl.__wzrNear = true; sl.classList.add('is-near'); hydrateSlide(sl); }
          now.push(k);
        }
        shown.forEach(function (k) {
          if (now.indexOf(k) === -1) { var sl = slides[k]; if (sl) { sl.style.opacity = 0; sl.__wzrNear = false; sl.classList.remove('is-near'); } }
        });
        shown = now;
                /* Swap info with the snap target (not halfway through the move) so text crossfades in step with the wheel */
                        var c = tween ? wrap(tween.to) : wrap(Math.round(p));
        setActive(c);
        var nx = slides[wrap(c + side + 1)];
        if (nx) hydrateSlide(nx);
      }
      function autoOn() { return BASE > 0 && !hover && !focused && visible && !document.hidden && n > 1; }
            /* Mobile: auto ticks start right away on load; any swipe/scroll stops them; resume after 10s untouched. One product every ~3s */
                  var IDLE_MS = 10000, TICK_MS = 3000, FIRST_MS = 1200, userTouched = false;
                        var idleUntil = performance.now(), nextTickAt = idleUntil + FIRST_MS;
                              function touchIdle() { userTouched = true; idleUntil = performance.now() + IDLE_MS; nextTickAt = idleUntil; kick(); }
      function frame(t) {
        raf = 0;
        if (!n) { last = 0; return; }
        var dt = last ? Math.min((t - last) / 1000, .05) : 0;
        last = t;
        if (drag) {
        } else if (tween) {
          var f = Math.min(1, (t - tween.t0) / tween.dur), e = 1 - Math.pow(1 - f, 3);
          pos = tween.from + (tween.to - tween.from) * e;
          if (f >= 1) { tween = null; vel = 0; }
        } else if (t < wheelUntil) {
          vel = 0;
        } else {
          var mob = isMobile();
          var target = (autoOn() && !mob) ? BASE : 0;
          if (mob && autoOn() && t >= idleUntil && t >= nextTickAt && Math.abs(vel) < .25) {
            nextTickAt = t + TICK_MS;
            step(1);
          }
          vel += (target - vel) * Math.min(1, dt * 2.2);
          if (Math.abs(vel - target) < 1e-4) vel = target;
          pos += vel * dt;
          if (target === 0 && Math.abs(vel) < .25) {
            var off = Math.round(pos) - pos;
            pos = Math.abs(off) < .002 ? Math.round(pos) : pos + off * Math.min(1, dt * 5);
          }
        }
        layout();
        if (drag || tween || t < wheelUntil || vel !== 0 || autoOn() || pos !== Math.round(pos)) kick();
        else last = 0;
      }
      function kick() { if (!raf && n) raf = requestAnimationFrame(frame); }
      function step(dir) {
        if (n < 2) return;
        var from = pos, base = tween ? tween.to : Math.round(pos);
        var to = base + dir;
        if (reduceMotion) { pos = to; tween = null; vel = 0; layout(); kick(); return; }
        tween = { from: from, to: to, t0: performance.now(), dur: isMobile() ? 280 : 650 };
        kick();
      }
      function goTo(k) {
        if (n < 2) return;
        var d = k - wrap(tween ? tween.to : Math.round(pos));
        if (d > n / 2) d -= n; else if (d < -n / 2) d += n;
        if (d) step(d);
      }
      function syncNav() {
        if (!box) return;
        var nav = box.querySelector('.wzr-rot__nav');
        if (n > 1) {
          if (!nav) {
            nav = document.createElement('div');
            nav.className = 'wzr-rot__nav';
            nav.innerHTML = '<button type="button" class="wzr-rot__arrow" data-wzr-rot="-1" aria-label="Previous product"><span aria-hidden="true">&larr;</span></button>'
              + (spinHintHtml || '')
              + '<button type="button" class="wzr-rot__arrow" data-wzr-rot="1" aria-label="Next product"><span aria-hidden="true">&rarr;</span></button>';
            box.appendChild(nav);
          } else {
            nav.hidden = false;
          }
        } else if (nav) {
          nav.hidden = true;
        }
      }
      function resetMotion() {
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
        pos = 0; vel = isMobile() ? 0 : BASE; active = 0;
                if (typeof touchIdle === 'function' && idleUntil) { if (userTouched) touchIdle(); else { idleUntil = performance.now(); nextTickAt = idleUntil + FIRST_MS; } } shown = []; tween = null; drag = null; last = 0; moved = false;
        if (box) box.classList.remove('is-dragging', 'is-paused');
      }
      function esc(s) {
        return String(s == null ? '' : s)
          .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      }
      function formatMoney(dollarStr) {
        var dollars = parseFloat(dollarStr);
        if (isNaN(dollars)) return '';
        var cents = Math.round(dollars * 100);
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          try { return Shopify.formatMoney(cents, moneyFormat); } catch (err) {}
        }
        return '$' + dollars.toFixed(2);
      }
      function imgWidth(src, w) {
        if (!src) return '';
        return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
      }
      function productAvailable(p) {
        var vs = p.variants || [];
        for (var i = 0; i < vs.length; i++) if (vs[i].available) return true;
        return false;
      }
      function firstVariant(p) {
        var vs = p.variants || [];
        for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
        return vs[0] || null;
      }
      function priceMeta(p) {
        var vs = p.variants || [];
        var prices = vs.map(function (v) { return parseFloat(v.price); }).filter(function (x) { return !isNaN(x); });
        var min = prices.length ? Math.min.apply(null, prices) : 0;
        var varies = prices.some(function (x) { return Math.abs(x - min) > 0.001; });
        var v = firstVariant(p);
        var price = v ? parseFloat(v.price) : min;
        var cmp = v && v.compare_at_price ? parseFloat(v.compare_at_price) : 0;
        return { price: price, compare: cmp, varies: varies, onSale: cmp > price, available: productAvailable(p), variantId: v ? v.id : null, onlyDefault: vs.length === 1 };
      }
      function ctaArrow() {
        return '<svg class="wzr-rot__cta-arrow" viewBox="0 0 20 20" width="16" height="16" fill="none" aria-hidden="true" focusable="false"><path d="M4 10h11M11 5.5 15.5 10 11 14.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      }
      function addIco() {
        return '<svg class="wzr-rot__cta2-ico" viewBox="0 0 20 20" width="16" height="16" fill="none" aria-hidden="true" focusable="false"><path d="M10 4.5v11M4.5 10h11" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
      }
      function buildSlideHtml(p, i) {
        var url = '/products/' + encodeURIComponent(p.handle);
        var img = (p.images && p.images[0]) ? p.images[0] : null;
        var activeCls = i === 0 ? ' is-active is-near' : '';
        var html = '<div class="wzr-rot__slide' + activeCls + '" data-wzr-slide aria-hidden="true">';
        html += '<a class="wzr-rot__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">';
        if (img && img.src) {
          var src = img.src;
          var w = img.width || '';
          var h = img.height || '';
          var cq = '';
          /* ncrop */
          var iw = function (u, wd) { return imgWidth(u, wd) + cq; };
          if (i < 4) {
            html += '<img class="wzr-rot__img" src="' + esc(iw(src, 600)) + '" srcset="'
              + esc(iw(src, 300)) + ' 300w, ' + esc(iw(src, 400)) + ' 400w, '
              + esc(iw(src, 600)) + ' 600w, ' + esc(iw(src, 800)) + ' 800w" sizes="(min-width: 750px) 330px, 210px" width="'
              + esc(w) + '" height="' + esc(h) + '" alt="" loading="lazy" decoding="async">';
          } else {
            html += '<img class="wzr-rot__img" data-wzr-src="' + esc(iw(src, 600)) + '" data-wzr-srcset="'
              + esc(iw(src, 300)) + ' 300w, ' + esc(iw(src, 400)) + ' 400w, '
              + esc(iw(src, 600)) + ' 600w, ' + esc(iw(src, 800)) + ' 800w" sizes="(min-width: 750px) 330px, 210px" width="'
              + esc(w) + '" height="' + esc(h) + '" alt="" decoding="async">';
          }
        } else {
          html += '<span class="wzr-rot__ph" aria-hidden="true"></span>';
        }
        html += '</a></div>';
        return html;
      }
      function buildInfoHtml(p, i) {
        var url = '/products/' + encodeURIComponent(p.handle);
        var meta = priceMeta(p);
        var activeCls = i === 0 ? ' is-active' : '';
        var hidden = i === 0 ? '' : ' aria-hidden="true" inert';
        var html = '<div class="wzr-rot__body' + activeCls + '" data-wzr-info role="group" aria-roledescription="slide" aria-label="' + esc(p.title) + '"' + hidden + '>';
        if (!meta.available || meta.onSale) {
          html += '<div class="wzr-rot__tags">';
          if (!meta.available) html += '<span class="wzr-tag wzr-tag--sold">Sold out</span>';
          if (meta.onSale && meta.available) {
            var pct = Math.round((meta.compare - meta.price) * 100 / meta.compare);
            html += '<span class="wzr-tag wzr-tag--sale">Save ' + pct + '%</span>';
          }
          html += '</div>';
        }
        if (p.product_type) html += '<p class="wzr-rot__type">' + esc(p.product_type) + '</p>';
        html += '<h3 class="wzr-rot__title"><a href="' + esc(url) + '">' + esc(p.title) + '</a></h3>';
        html += '<p class="wzr-rot__price">';
        if (meta.varies) html += 'From ';
        html += esc(formatMoney(meta.price));
        if (meta.onSale) html += ' <s>' + esc(formatMoney(meta.compare)) + '</s>';
        html += '</p>';
        html += '<div class="wzr-rot__actions">';
        html += '<a class="wzr-btn wzr-rot__cta" href="' + esc(url) + '"><span class="wzr-rot__cta-label">' + esc(btnLabel) + '</span>' + ctaArrow() + '</a>';
        if (addLabel && meta.available && meta.onlyDefault && meta.variantId) {
          html += '<form class="wzr-rot__form wzr-fly-add" action="' + esc(cartUrl) + '" method="post" data-wzr-fly-add>';
          html += '<input type="hidden" name="id" value="' + esc(meta.variantId) + '">';
          html += '<input type="hidden" name="quantity" value="1">';
          html += '<button type="submit" class="wzr-btn wzr-rot__cta2">' + addIco() + '<span class="wzr-rot__cta-label">' + esc(addLabel) + '</span></button>';
          html += '</form>';
        }
        html += '</div></div>';
        return html;
      }
      function rebuild(products) {
        if (!box || !ring || !infoWrap) return;
        var list = products || [];
        var slidesHtml = '';
        var infosHtml = '';
        for (var i = 0; i < list.length; i++) {
          slidesHtml += buildSlideHtml(list[i], i);
          infosHtml += buildInfoHtml(list[i], i);
        }
        ring.innerHTML = slidesHtml;
        infoWrap.innerHTML = infosHtml;
        refreshRefs();
        resetMotion();
        if (emptyEl) emptyEl.hidden = n > 0;
        syncNav();
        if (!n) return;
        measure();
        layout();
        kick();
      }
      function loadCategory(handle) {
        if (catCache[handle]) return Promise.resolve(catCache[handle]);
        var url = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + maxProducts;
        return fetch(url, { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('Failed to load collection');
          return r.json();
        }).then(function (data) {
          var products = (data && data.products) ? data.products.slice() : [];
          if (hideSold) products = products.filter(productAvailable);
          catCache[handle] = products;
          return products;
        });
      }
      function setActiveChip(btn) {
        if (!catBar) return;
        catBar.querySelectorAll('[data-wzr-cat]').forEach(function (el) {
          var on = el === btn;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      function bindCategories() {
        if (!catBar) return;
        var existingNav = box && box.querySelector('.wzr-rot__nav');
        if (existingNav) {
          var hint = existingNav.querySelector('.wzr-rot__hint');
          if (hint) spinHintHtml = hint.outerHTML;
        }
        catBar.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-wzr-cat]');
          if (!btn || catLoading) return;
          if (btn.classList.contains('is-active')) return;
          var handle = btn.getAttribute('data-wzr-cat');
          var catUrl = btn.getAttribute('data-wzr-cat-url') || ('/collections/' + handle);
          if (!handle) return;
          catLoading = true;
          btn.classList.add('is-loading');
          btn.disabled = true;
          if (box) box.classList.add('is-swap');
          loadCategory(handle).then(function (products) {
            setActiveChip(btn);
            if (viewAll) viewAll.setAttribute('href', catUrl);
            rebuild(products);
          }).catch(function () {
            if (emptyEl) { emptyEl.hidden = false; emptyEl.textContent = 'Could not load this category. Try again.'; }
          }).then(function () {
            catLoading = false;
            btn.classList.remove('is-loading');
            btn.disabled = false;
            if (box) box.classList.remove('is-swap');
          });
        });
      }

      refreshRefs();
      if (!box || !ring) { bindCategories(); return; }
      if (!infoWrap) infoWrap = box.querySelector('.wzr-rot__info');

      measure(); layout();
      window.addEventListener('resize', function () { measure(); layout(); });

      root.addEventListener('click', function (e) {
        var arrow = e.target.closest('[data-wzr-rot]');
        if (arrow) { step(parseInt(arrow.getAttribute('data-wzr-rot'), 10)); return; }
        /* A swipe that started on the title/price/buttons must not also click the link/button under the finger */
        if (moved && e.target.closest('.wzr-rot')) { e.preventDefault(); e.stopPropagation(); moved = false; return; }
        var sl = e.target.closest('[data-wzr-slide]');
        if (!sl) return;
        if (!sl.classList.contains('is-active')) { e.preventDefault(); goTo(slides.indexOf(sl)); }
      }, true);
      root.addEventListener('keydown', function (e) {
        if (e.target.closest('input, textarea, select')) return;
        if (e.key === 'ArrowLeft') { step(-1); } else if (e.key === 'ArrowRight') { step(1); }
      });
      ring.addEventListener('dragstart', function (e) { e.preventDefault(); });
      function inStage(e) {
        /* Swipe zone = the packs AND the title / price / product text under them (was packs only,
           so a finger on the title or price could not spin the wheel). Arrows, chips and inputs stay tappable. */
        if (e.target.closest('.wzr-rot__nav, .wzr-rot-cats, input, select, textarea')) return false;
        if (e.target.closest('.wzr-rot__info')) return true;
        var r = ring.getBoundingClientRect();
        return e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      }

      box.addEventListener('pointerdown', function (e) {
        touchIdle();
        if (e.button !== 0 || n < 2 || !inStage(e)) return;
        tween = null;
        drag = { id: e.pointerId, x: e.clientX, y: e.clientY, p: pos, lx: e.clientX, lt: performance.now(), v: 0, on: false };
        moved = false;
      });
      box.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x;
        if (!drag.on) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(e.clientY - drag.y) > Math.abs(dx)) { drag = null; return; }
          drag.on = true; moved = true; box.classList.add('is-dragging');
          try { box.setPointerCapture(e.pointerId); } catch (err) {}
        }
        var now = performance.now(), dtm = Math.max(1, now - drag.lt);
        var inst = -(e.clientX - drag.lx) / stepPx() / (dtm / 1000);
        drag.v = drag.v * .6 + inst * .4;
        drag.lx = e.clientX; drag.lt = now;
        pos = drag.p - dx / stepPx();
        /* Mobile: finger drag can preview at most one product either way */
        if (isMobile()) pos = Math.max(drag.p - 1, Math.min(drag.p + 1, pos));
        kick();
      });
      function endDrag(e) {
        if (!drag || (e && e.pointerId !== drag.id)) return;
        var d = drag;
        drag = null;
        box.classList.remove('is-dragging');
        touchIdle();
        if (!d.on) return;
        setTimeout(function () { moved = false; }, 0);
        if (performance.now() - d.lt > 120) d.v = 0;
        if (reduceMotion) { vel = 0; step(0); return; }
        /* Mobile: one swipe = exactly one product. No velocity coast. */
        if (isMobile()) {
          vel = 0;
          var ddx = (e && e.type === 'pointerup' && e.clientX !== undefined) ? (e.clientX - d.x) : (d.lx - d.x);
          var start = Math.round(d.p);
          var mdir = Math.abs(ddx) > 18 ? (ddx < 0 ? 1 : -1) : 0;
          if (!mdir && Math.abs(d.v) > 0.6) mdir = d.v > 0 ? 1 : -1;
          tween = { from: pos, to: start + mdir, t0: performance.now(), dur: 280 };
          kick();
          return;
        }
        var cap = 8;
        vel = Math.max(-cap, Math.min(cap, d.v));
        kick();
      }
      box.addEventListener('pointerup', endDrag);
      box.addEventListener('touchstart', function () { touchIdle(); }, { passive: true });
      root.addEventListener('click', function () { touchIdle(); }, true);
      root.addEventListener('change', function () { touchIdle(); }, true);
      box.addEventListener('pointercancel', endDrag);
      box.addEventListener('lostpointercapture', endDrag);

      box.addEventListener('wheel', function (e) {
        var dx = e.deltaX;
        if (!dx && e.shiftKey) dx = e.deltaY;
        if (!dx || Math.abs(dx) < Math.abs(e.deltaY) && !e.shiftKey || n < 2) return;
        e.preventDefault();
        if (e.deltaMode === 1) dx *= 16; else if (e.deltaMode === 2) dx *= ring.clientWidth;
        tween = null;
        touchIdle();
        pos += dx / stepPx();
        wheelUntil = performance.now() + (reduceMotion ? 0 : 350);
        if (reduceMotion) { clearTimeout(box.__wzrSnap); box.__wzrSnap = setTimeout(function () { step(0); }, 180); }
        kick();
      }, { passive: false });

      box.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' || e.pointerType === 'pen') { hover = true; box.classList.add('is-paused'); kick(); } });
      box.addEventListener('pointerleave', function () { hover = false; box.classList.remove('is-paused'); kick(); });
      root.addEventListener('focusin', function (e) {
        var fv = false;
        try { fv = e.target.matches(':focus-visible'); } catch (err) { fv = true; }
        focused = fv; kick();
      });
      root.addEventListener('focusout', function (e) {
        if (!e.relatedTarget || !root.contains(e.relatedTarget)) { focused = false; kick(); }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { visible = en.isIntersecting; kick(); });
        }, { threshold: 0.15 }).observe(box);
      }
      document.addEventListener('visibilitychange', kick);
      // Persist wheel spot per page + category chip (sessionStorage) so refresh / chip switch keeps the user's place
      var wzrKeyBase = 'wzrRot:' + location.pathname + ':' + (root.id || '') + ':';
      function wzrCat() { var c = catBar && catBar.querySelector('[data-wzr-cat].is-active'); return c ? c.getAttribute('data-wzr-cat') : 'default'; }
      function wzrRestore() { try { sessionStorage.setItem(wzrKeyBase + '__cat', wzrCat()); var v = parseInt(sessionStorage.getItem(wzrKeyBase + wzrCat()), 10); if (v > 0 && v < n) { tween = null; vel = 0; pos = v; layout(); kick(); } } catch (err) {} }
      var wzrSaveT = 0, wzrSavedCat = null;
      try { wzrSavedCat = sessionStorage.getItem(wzrKeyBase + '__cat'); } catch (err) {}
      if (ring && window.MutationObserver) new MutationObserver(function (recs) {
        if (recs.some(function (r) { return r.type === 'childList'; })) { wzrRestore(); return; }
        clearTimeout(wzrSaveT);
        wzrSaveT = setTimeout(function () { try { sessionStorage.setItem(wzrKeyBase + wzrCat(), String(active)); sessionStorage.setItem(wzrKeyBase + '__cat', wzrCat()); } catch (err) {} }, 150);
      }).observe(ring, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      wzrRestore();
      setTimeout(function () { try { var sc = wzrSavedCat; if (sc && catBar && sc !== wzrCat()) { var b = catBar.querySelector('[data-wzr-cat="' + sc.replace(/"/g, '') + '"]'); if (b) b.click(); } } catch (err) {} }, 0);
      root.__wzrGo = goTo;
      root.__wzrRebuild = rebuild;
      bindCategories();
      if (n) kick();
    }

    function initAll() {
      document.querySelectorAll('[data-wzr-shorts]').forEach(initShorts);
      document.querySelectorAll('[data-wzr-rotator]').forEach(initRotator);
    }
    document.addEventListener('visibilitychange', function () {
      allCards().forEach(function (c) {
        if (document.hidden) { if (c.__wzrPlaying) { c.__wzrResume = true; pause(c, true); } }
        else if (c.__wzrResume && c.__wzrVisible) { c.__wzrResume = false; play(c); }
      });
    });
    document.addEventListener('shopify:section:load', initAll);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  })();

  } catch(e) { console.error(e); }
})();
})();
